import { styled } from 'styled-system/jsx'

const Card = styled('div', {
  base: {
    width: '100%',
    backgroundColor: '#FFFFFF',
    borderRadius: 'lg',
    padding: '20px 22px',
    border: '1.5px solid',
    borderColor: '#F0EDFA',
    boxShadow: '0 12px 32px -22px rgba(128, 84, 255, 0.18)',
    display: 'flex',
    alignItems: 'center',
    gap: '18px',
    flexWrap: 'wrap',
  },
})

const Glyph = styled('div', {
  base: {
    width: '64px',
    height: '64px',
    borderRadius: 'pill',
    background:
      'linear-gradient(135deg, {colors.quickpass.primary} 0%, {colors.quickpass.warmth} 100%)',
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: '30px',
    flexShrink: '0',
    boxShadow: '0 12px 24px -12px rgba(128, 84, 255, 0.55)',
  },
})

const NumberBlock = styled('div', {
  base: {
    display: 'flex',
    flexDirection: 'column',
    gap: '2px',
    flex: '1',
    minWidth: '180px',
  },
})

const NumberValue = styled('div', {
  base: {
    fontFamily: 'display',
    fontSize: '34px',
    fontWeight: '800',
    color: 'quickpass.ink',
    letterSpacing: '-0.6px',
    lineHeight: '1.1',
  },
})

const NumberHint = styled('div', {
  base: {
    fontFamily: 'body',
    fontSize: '13px',
    color: 'quickpass.inkSoft',
    lineHeight: '1.4',
  },
})

const SetterRow = styled('div', {
  base: {
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    flexWrap: 'wrap',
  },
})

const SetterInput = styled('input', {
  base: {
    fontFamily: 'body',
    fontSize: '13px',
    color: 'quickpass.ink',
    backgroundColor: 'quickpass.surfaceCool',
    border: '1.5px solid',
    borderColor: '#E5E0F5',
    borderRadius: 'pill',
    paddingX: '14px',
    paddingY: '6px',
    cursor: 'pointer',
    transition:
      'border-color {durations.fast} {easings.appleStandard}, background-color {durations.fast} {easings.appleStandard}',
    _focus: {
      outline: 'none',
      borderColor: 'quickpass.primary',
      backgroundColor: '#FFFFFF',
    },
  },
})

const SetterButton = styled('button', {
  base: {
    fontFamily: 'body',
    fontSize: '12px',
    fontWeight: '600',
    color: 'quickpass.inkSoft',
    backgroundColor: 'transparent',
    border: 'none',
    cursor: 'pointer',
    paddingX: '8px',
    paddingY: '4px',
    transition: 'color {durations.fast} {easings.appleStandard}',
    _hover: { color: 'quickpass.warmth' },
  },
})

const PromptCard = styled('div', {
  base: {
    width: '100%',
    backgroundColor: 'quickpass.surfaceCool',
    borderRadius: 'lg',
    padding: '14px 18px',
    border: '1.5px dashed',
    borderColor: '#E5E0F5',
    display: 'flex',
    alignItems: 'center',
    gap: '12px',
    flexWrap: 'wrap',
  },
})

const PromptText = styled('div', {
  base: {
    flex: '1',
    minWidth: '180px',
    display: 'flex',
    flexDirection: 'column',
    gap: '2px',
  },
})

const PromptTitle = styled('span', {
  base: {
    fontFamily: 'display',
    fontSize: '14px',
    fontWeight: '700',
    color: 'quickpass.ink',
  },
})

const PromptHint = styled('span', {
  base: {
    fontFamily: 'body',
    fontSize: '12px',
    color: 'quickpass.inkSoft',
  },
})

export {
  Card,
  Glyph,
  NumberBlock,
  NumberValue,
  NumberHint,
  SetterRow,
  SetterInput,
  SetterButton,
  PromptCard,
  PromptText,
  PromptTitle,
  PromptHint,
}
